<script setup lang="ts">
import {Section} from "@/types";
import AddedCourseItem from "components/course/detail/AddedCourseItem.vue";

const props = defineProps<{
  status: number,
  courses: Section[]
}>()

const emit = defineEmits(["addCourse", "del", "detail"]);

const addCourse = () => {
  emit("addCourse");
}

const onDel = (id: number) => {
  emit("del", id)
}

const detail = (id: number) => {
  emit("detail", id)
}
</script>

<template>
  <div class="py-1.5rem px-2rem bg-white rounded-md shadow-md">
    <div class="text-[rgba(0,0,0,0.85)] text-1.25em font-bold">全部课程</div>
    <added-course-item :status="status" v-for="course in props.courses" :course="course" @del="onDel" @detail="detail"/>
    <div class="plus-container border-dashed py-3.75rem border-1px
     border-#D9D9D9 mt-2rem flex justify-center items-center
     text-[rgba(0,0,0,0.65)] text-.875em cursor-pointer" @click="addCourse" v-if="status === 2">
      <img src="@/assets/image/icon/icon-plus.png" alt="plus-icon" class="w-.875rem h-.875rem"/>
      <span class="ml-.5rem" >新增课程</span>
    </div>
  </div>
</template>

<style scoped>
</style>
